<template>
  <div>
    <div class="navbar-wrapper" data-aos="fade-in" data-aos-once="true">
      <div class="container navbar-row first is-fluid" style="margin-left:0;margin-right:0;">
        <div class="container">
          <div class="columns navbar-full first is-gapless is-mobile">
            <div class="column navbar-brand" align="left" style="">
              <div class="navbar-logo">
                <img src="../assets/logo.svg" width="85" class="img-responsive logo-1" />
                <img src="../assets/logo-text.svg" width="360" class="img-responsive logo-2 is-hidden-mobile" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="container navbar-row second is-fluid" style="margin-left:0;margin-right:0;">
      </div>
    </div>
    <div class="page page-survey container is-fluid">
      <div class="container container-inner">
        <div class="columns is-flex is-gapless is-multiline" style="flex-direction:column;">

          <div class="column is-12 is-mobile-12 content content-main is-right" style="padding-left:0.7rem;padding-right:0.7rem;padding-bottom:0.2rem;">
            <div class="title">
              {{ 'Exit Survey' }}
            </div>
          </div>
          <br />
          <div class="column is-12 is-mobile-12 is-centered">
            <div v-if="isSurveyState == null" class="columns is-gapless is-centered is-multiline">
              <div class="column is-6">
                <div class="box color-gray-lighter-bg">
                  <div class="subtitle" style="margin-bottom:0.8em;">
                    {{ isSurveyError }}
                    <div style="width:100%;text-align:center;margin-top:24px;">
                      <el-button class="button" type="info" @click="$router.push('/')">Back to Home</el-button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="isSurveyState === 'code'" class="columns is-gapless is-centered is-multiline">
              <div class="column is-6">
                <div class="box color-gray-lighter-bg">
                  <div class="subtitle" style="margin-bottom:0.8em;">
                    {{ 'Survey Code' }}
                  </div>
                  <div class="text">
                    Please enter the survey code below.
                  </div>
                  <form-input name="surveyCode" :value="surveyCode" placeholder="" :error="surveyError" @onInput="onSurveyInput" />
                  <div>
                    <button class="control button is-outlined" :class="{ 'is-loading': loading }" @click="() => onSurveyCode(surveyCode)">
                      <p>{{ loading ? '&nbsp;' : 'SUBMIT' }}</p>
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="isSurveyState === 'survey'">
              <form-dynamix type="team" :feedback="feedback" :loading="loading" v-if="!submitted"
                :names="names" :models="models" :attributes="attributes"
                :vuelidate="$v"
                :is-print="isPrint"
                :is-print-pdf="isPrintPdf"
                @recaptcha="onRecaptcha"
                @send="onSend">
              </form-dynamix>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script type="text/javascript">
// import _ from 'lodash'
import EventBus from '@/controllers/EventBus'
import DivContainer from '@/components/DivContainer'
import DivColumns from '@/components/DivColumns'
import PageSubheader from '@/components/PageSubheader'
import FormDynamix from '@/components/FormDynamix'
import FormInput from '@/components/FormInput'
import { validationMixin } from 'vuelidate'
// import { required, numeric, email, between, minLength, maxLength } from 'vuelidate/lib/validators'
import { required } from 'vuelidate/lib/validators'
import Site from '@/apis/Site'
import moment from 'moment'
// import imageMap from '@/assets/map.png'
import AuthUtil from '@/utils/auth'

// function validateArrayRequired (values) {
//   if (values && values.length > 0) {
//     var isChecked = false
//     for (var i = 0; i < values.length; i++) {
//       var value = values[i]
//       isChecked |= value
//     }
//     return isChecked
//   }
//   return false
// }

// function validateEitherOr (value1, value2) {
//   // console.log('-- validate either or --')
//   // console.log(value1)
//   // console.log(value2)
//   if (value1 && !value2) {
//     return true
//   } else if (!value1 && value2) {
//     return true
//   }
//   return false
// }

export default {
  name: 'section-sign-up-team',
  mixins: [validationMixin],
  components: {
    DivContainer,
    DivColumns,
    PageSubheader,
    FormDynamix,
    FormInput
  },
  props: ['is-print'],
  watch: {
    'isPrint': {
      handler: function (value, _oldValue) {
        var isPrint = value
        if (isPrint) {
          this.models.signAt = ''
        } else {
          this.models.signAt = (moment(new Date())).format()
        }
      }
    },
    'models.competition': {
      handler: function (value, oldValue) {
        var disabled = (value !== 1)
        this.attributes.volunteer.disabled = disabled
        if (disabled) {
          this.models.volunteer = undefined
        }
        // if (value[2] !== oldValue[2]) {
        // var changed = value.filter(function (p, idx) {
        //   return Object.keys(p).some(function (prop) {
        //     return p[prop] !== oldValue[idx][prop]
        //   })
        // })
        // console.log('changed-value...')
        // console.log(changed)

        if (value !== oldValue && value === 1) {
          this.models.competition2 = false
        }
      },
      deep: true
    },
    'models.competition2': {
      handler: function (value, oldValue) {
        if (value !== oldValue && value === 2) {
          this.models.competition = false
        }
      }
    },
    'models.members': {
      handler: function (value, oldValue) {
        console.log('member change: ' + value)
      }
    }
  },
  computed: {
    // isDesktop: function () {
    //   return EventBus.isDesktop
    // }
  },
  data: function () {
    return {
      isDesktop: true,
      isIE: EventBus.detectIE(),
      isPrintPdf: '/static/team-application.pdf',
      isSurveyError: '...',
      isSurveyState: undefined,
      surveyCode: '',
      surveyCodeConfirm: undefined,
      surveyError: [],
      // captcha: '',
      // captchaImage: undefined,
      // session: '',
      feedback: false,
      submitted: false,
      loading: false,
      items: [],
      names: [
        // form
        'term',
        'officer',
        'isExplained',
        'labelCheck', // label
        'isRespectful',
        'isAnswered',
        'isTreated',
        'labelNote', // label
        'note',
        'name'
      ],
      models: {
        // form
        recaptcha: undefined,
        term: '',
        officer: '',
        isExplained: undefined,
        isRespectful: undefined,
        isAnswered: undefined,
        isTreated: undefined,
        note: '',
        name: ''
      },
      attributes: {
        // form
        term: {
          title: 'How long was your probation term?',
          column: 'is-12'
        },
        officer: {
          title: '1. Who was your probation officer at the time the case was closed?',
          column: 'is-12'
        },
        isExplained: {
          type: 'radio',
          title: '2. During your first appointment, were your supervision requirements explained to you so you could understand them.',
          column: 'is-12',
          options: [{
            value: 'yes',
            title: 'YES'
          }, {
            value: 'no',
            title: 'NO'
          }],
          onChecked: function (value) {
            console.log(value)
          }
        },
        labelCheck: {
          type: 'label',
          title: 'Please answer these questions about your assigned probation officer at the time the case was closed.',
          style: {
            fontStyle: 'italic'
          }
        },
        isRespectful: {
          type: 'radio',
          title: '3. Was your probation officer respectful and courteous to you?',
          column: 'is-12',
          options: [{
            value: 'always',
            title: 'Always'
          }, {
            value: 'usually',
            title: 'Usually'
          }, {
            value: 'sometimes',
            title: 'Sometimes'
          }, {
            value: 'rarely',
            title: 'Rarely'
          }, {
            value: 'never',
            title: 'Never'
          }]
        },
        isAnswered: {
          type: 'radio',
          title: '4. Were questions about your case conditions answered during office visits?',
          column: 'is-12',
          options: [{
            value: 'always',
            title: 'Always'
          }, {
            value: 'usually',
            title: 'Usually'
          }, {
            value: 'sometimes',
            title: 'Sometimes'
          }, {
            value: 'rarely',
            title: 'Rarely'
          }, {
            value: 'never',
            title: 'Never'
          }]
        },
        isTreated: {
          type: 'radio',
          title: '5. Did you feel you were treated as an individual and not just "a number".',
          column: 'is-12',
          options: [{
            value: 'yes',
            title: 'YES'
          }, {
            value: 'no',
            title: 'NO'
          }]
        },
        labelNote: {
          type: 'label',
          title: 'If we have earned a good review, would you please take a moment to leave a 5 star review on Google @ Client Management Probation.  If we did not meet expectations, please use the space below to make any further comments about your experience that could help us improve.',
          style: {
            fontWeight: 'bold'
          }
        },
        note: {
          type: 'textarea',
          title: '',
          curLength: 0,
          maxLength: 500
        },
        name: {
          title: 'Name (optional)',
          column: 'is-12'
        }
        // signature: {
        //   title: 'Team Leader\'s Name',
        //   column: 'is-6'
        //   // note: '* By typing your name, you agree to the above.<br />' +
        //   // `* By typing your name and submitting this Team A pplication, you agree to the above and agree to follow all of the COVID-19 restrictions & regulations stated in the “Emergency Addendum to KCBS Sanctioning Agreement” attached above.`
        // },
        // signAt: {
        //   title: 'Date',
        //   column: 'is-6',
        //   disabled: true
        // },
        // signNote: {
        //   null: true,
        //   title: 'Note',
        //   column: 'is-12',
        //   note: '* By typing your name, you agree to the above.<br />' +
        //   `* By typing your name and submitting this Team Application, you agree to the above and agree to follow all of the COVID-19 restrictions & regulations enforced locally as well as any KCBS guidelines/addendums that may arise.`
        // }
      },
      navEmail: EventBus._data._navEmail
    }
  },
  validations: {
    models: {
      // form
      recaptcha: { required },
      term: { required },
      officer: { required },
      isExplained: { required },
      labelCheck: {}, // label
      isRespectful: { required },
      isAnswered: { required },
      isTreated: { required },
      labelNote: {}, // label
      note: { required },
      name: {}
    }
  },
  created: function () {
    // console.log('-- creating... --')
    // console.log(this.$v)
    // console.log(this.models)
    this.init()
  },
  mounted: function () {
    // console.log('-- mounted... --')
    // on event resize
    this.isDesktop = EventBus._isDesktop
    EventBus.$on('isDesktopChanged', function () {
      this.isDesktop = EventBus._isDesktop
    }.bind(this))

    // this.onRecaptcha(data => {
    //   // console.log('recaptcha data!')
    //   this.captchaImage = data.data
    //   this.session = data.id
    // })

    if (this.isPrint) {
      this.models.signAt = ''
    } else {
      this.models.signAt = (moment(new Date())).format()
    }

    // console.log('-- mounting... --')
    // console.log(this.$v)
    this.onLoad()
  },
  methods: {
    init: async function () {
      try {
        this.loading = true
        let promises = []
        promises.push(this.getSurveyCode())
        promises.push(this.getSurveyStatus())
        let [code, status] = await Promise.all(promises)
        // console.log('-- survey', code, status)
        if (code != null && code.length <= 0) {
          this.isSurveyError = 'Invalid survey code'
          this.loading = false
          return
        }
        this.surveyCodeConfirm = code
        if (status === 'submitted') {
          this.isSurveyError = 'You have already completed the exit survey previously. Thank you for your response.'
          this.loading = false
          return
        }
        if (status !== 'ready') {
          this.isSurveyError = 'Invalid survey'
          this.loading = false
          return
        }
        this.isSurveyState = 'code'
        this.loading = false
      } catch (error) {
        console.log(error)
        this.loading = false
      }
    },

    onLoad: function () {
    },

    getSurveyCode: async function () {
      let response = await Site.infoNamed('survey-code')
      let metaString = response && response[0] && response[0].meta
      let meta = JSON.parse(metaString)
      let code = meta && meta.code
      return code
    },

    getSurveyStatus: async function () {
      // let response = await Site.surveyStatus(this.$route.params.code)
      // return response && response.status
      return await AuthUtil.getSurveyStatus() || 'ready'
    },

    onRecaptcha: function (info) {
      if (info && info.status) {
        this.models.recaptcha = (info.status === 'ok' ? info.response : undefined)
        if (info.status !== 'ok') {
          console.log('FormDynamix:recaptcha():' + info.status)
        }
      }
    },

    onClear: function () {
      // this.models.recaptcha = undefined
      // form
      this.models.term = ''
      this.models.officer = ''
      this.models.isExplained = undefined
      this.models.isRespectful = undefined
      this.models.isAnswered = undefined
      this.models.isTreated = undefined
      this.models.note = ''
      this.models.name = ''
    },

    onSurveyInput: function (info) {
      this.surveyCode = info && info.value
    },

    onSurveyCode: function (surveyCode) {
      this.surveyError.splice(0, this.surveyError.length)
      if (surveyCode == null || surveyCode.length <= 0) {
        this.surveyError.splice(0, this.surveyError.length, 'required')
        return
      }
      if (surveyCode !== this.surveyCodeConfirm) {
        this.surveyError.splice(0, this.surveyError.length, 'invalid')
        return
      }
      this.isSurveyState = 'survey'
      // this.surveyCode = surveyCode
    },

    onSendDisabled: function () {
      var _self = this
      _self.feedback = 'We are sorry, team application is not open yet.'
      return
    },

    onSend: function (formInfo) {
      // $v.models.$touch()
      var _self = this
      console.log('SignUpTeamSection:onSend(): $v / models')
      console.log(formInfo)

      // var models = formInfo.models
      if (formInfo.vuelidate.$invalid) {
        _self.feedback = 'Form contains errors, please recheck.'
        // _self.$toast.open({
        //   duration: 5000,
        //   message: 'Please fill in all fields to proceed.',
        //   position: 'is-bottom',
        //   type: 'is-warning'
        // })
        return
      }

      // if (this.$route.params.code == null || this.$route.params.code.length <= 0) {
      //   _self.feedback = 'Invalid survey code, please check again.'
      //   return
      // }
      // let code = this.$route.params.code

      if (!this.models.recaptcha) {
        _self.feedback = 'Invalid recaptcha, please validate again.'
        return
      }
      _self.feedback = false

      var models = formInfo.models

      console.log('-- send form --')
      console.log(models)
      // console.log(models.name)
      // console.log(models.leader)
      // console.log(models.members)
      // console.log(competition)
      // console.log(models.freeStrawberry)
      // console.log(models.freeKingOfWing)
      // console.log(models.signature)
      // console.log(models.signAt)
      // console.log(models.amount)

      // if (formInfo) {
      //   return
      // }

      _self.loading = true
      Site.surveySubmit(models)
      .then(data => {
        _self.loading = false

        // invalid captcha
        if (data && data.status === 'invalid_session') {
          _self.feedback = 'Invalid session, please kindly refresh and try again.'
          return
        }

        // invalid captcha
        if (data && data.status === 'invalid_captcha') {
          _self.feedback = 'Invalid captcha, please re-type again.'
          return
        }

        if (data && data.status !== 'ok') {
          _self.feedback = 'Oops. Something went wrong. Please email us directly at ' + _self.navEmail
          return
        }

        this.$v.models.$reset()
        this.onClear()

        // _self.captcha = ''
        // _self.session = '' // open up to maintain session

        // _self.$toast.open({
        //   message: 'We will be contacting you via email or phone. Thanks!',
        //   position: 'is-bottom',
        //   type: 'is-success'
        // })
        _self.submitted = true
        _self.feedback = 'Your application has been successfully submitted.'
        AuthUtil.setSurveyStatus('submitted')
      })
      .catch(error => {
        console.log('invalid email', error)
        // this.error = error.error
        console.log(error)
        // _self.captcha = ''

        // invalid captcha
        if (error && error.status === 'invalid_session') {
          _self.feedback = 'Invalid session, please kindly refresh and try again.'
          _self.loading = false
          return
        }

        // invalid captcha
        if (error && error.status === 'invalid_captcha') {
          _self.feedback = 'Invalid captcha, please retype again.'
          _self.loading = false
          return
        }

        // _self.$toast.open({
        //   duration: 5000,
        //   message: 'Oops. Something went wrong. Please email us directly at ' + _self.navEmail,
        //   position: 'is-bottom',
        //   type: 'is-warning'
        // })
        _self.feedback = 'Oops. Something went wrong. Please email us directly at ' + _self.navEmail
        _self.loading = false
        return _self.init()
      }).then(data => {
        this.isSurveyState = undefined
        this.isSurveyError = 'Survey has been submitted successfully. Thank you for your response.'
        console.log('submit/success')
      })
    }
  }
}
</script>

<style lang="scss">
@import "../styles/app_setting.scss";
@import "../styles/page.scss";

.navbar-wrapper {
  align-items: center;

  .navbar-brand {
    .navbar-logo {
      padding: 0.78rem;
    }
    .logo-1 {
      padding-left: 10px;
      vertical-align: middle;
      max-width: auto;
      // margin-top: 12px;
      // margin-bottom: 12px;

      @media screen and (max-width: ($desktop - 1)) {
        width: 60px;
        padding: 5px;
        margin-left: 30px;
      }

      @media screen and (min-width: $desktop) {
        width: 80px;
        padding: 10px;
      }
    }

    .logo-2 {
      vertical-align: middle;
      max-width: auto;
      padding: 10px;

      @media screen and (max-width: ($desktop - 1)) {
        width: 280px;
        padding: 5px;
      }

      @media screen and (min-width: $desktop) {
        width: 340px;
        // padding: 15px;
      }
    }
  }

  .navbar-row {
    &.first {
      background-color: transparent;

      // only for desktop
      @media screen and (min-width: $tablet) {
        background-color: white;
      }
    }

    &.second {
      background-color: transparent;
      height: 45px;

      // only for desktop
      @media screen and (min-width: $tablet) {
        background-color: $color-primary-blue;
      }
    }
  }
}

.page-survey {
  // padding: 1rem 0;
  // margin-top: 4em;
  // margin-bottom: 2em;
  padding: 0 0.75rem 3rem 0.75rem;
  // -webkit-print-color-adjust: exact;
  .subtitle {
    text-transform: none;
    line-height: 1.5;
  }

  .button {
    font-size: 1rem;
    color: white;
    background-color: black;
    span {
      text-transform: uppercase;
    }
  }
}
</style>



// WEBPACK FOOTER //
// survey.vue?2b672161